import React from 'react';
import { Check } from 'lucide-react';
export function BonusSection() {
  return <section className="bg-dark py-28 md:py-32 px-4 border-t border-gray-800" data-id="element-27">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center" data-id="element-28">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-textLight mb-6 text-center" data-id="element-29">
          Lo que te llevas el sábado.
        </h2>
        <p className="text-xl md:text-2xl text-textSecondary mb-16 text-center" data-id="element-30">
          Para que esto no se vuelva a desordenar al lunes.
        </p>

        <div className="flex flex-col items-start text-left gap-6 w-full max-w-2xl mx-auto mb-24" data-id="element-31">
          <div className="flex items-start gap-4" data-id="element-32">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-33" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-34">
              Criterio para eliminar lo que solo te mantiene ocupada.
            </span>
          </div>
          <div className="flex items-start gap-4" data-id="element-35">
            <Check className="text-accentSecondary shrink-0 mt-1" size={24} data-id="element-36" />
            <span className="text-lg md:text-xl text-textLight font-medium" data-id="element-37">
              Enfoque sobre el 20% que sí impacta crecimiento.
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 w-full" data-id="element-38">
          <div className="bg-[#111111] border border-gray-800 rounded-2xl p-8 md:p-12 flex flex-col items-center text-center" data-id="element-39">
            <div className="w-full rounded-xl mb-8 overflow-hidden" data-id="element-40">
              <img src="https://cdn.magicpatterns.com/uploads/epiqkKU9zAULSLybeS278p/Mock_up_Bono_80_20_real.jpg" alt="Bono 1 — Delegación Inteligente" className="w-full h-auto object-cover" data-id="element-41" />
            </div>
            <h3 className="font-serif text-2xl font-bold text-accent mb-4" data-id="element-42">
              BONO 1 · Delegación Inteligente
            </h3>
            <p className="text-lg text-textLight leading-relaxed" data-id="element-43">
              la arquitectura para dejar de ser el cuello de botella de tu
              propio negocio.
            </p>
          </div>

          <div className="bg-[#111111] border border-gray-800 rounded-2xl p-8 md:p-12 flex flex-col items-center text-center" data-id="element-44">
            <div className="w-full rounded-xl mb-8 overflow-hidden" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/vBPF4PofKGKiefm6wsEZ6s/Bono_2_delegacion_inetlugente.jpg" alt="Bono 2 — Mapa 80/20 Real" className="w-full h-auto object-cover" data-id="element-46" />
            </div>
            <h3 className="font-serif text-2xl font-bold text-accent mb-4" data-id="element-47">
              BONO 2 · Mapa 80/20 Real
            </h3>
            <p className="text-lg text-textLight leading-relaxed" data-id="element-48">
              para sostener solo lo que sí funciona y soltar el resto.
            </p>
          </div>
        </div>
      </div>
    </section>;
}